import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "springWaterDetail debug test3D"
};
const _hoisted_2 = {
  class: "desTitle",
  id: "desTitle"
};
const _hoisted_3 = {
  key: 1,
  class: "containRelicsImg"
};
const _hoisted_4 = {
  class: "imagslist"
};
const _hoisted_5 = {
  class: "swiper-container swiperImg",
  ref: "swiperImg"
};
const _hoisted_6 = {
  class: "swiper-wrapper"
};
const _hoisted_7 = {
  class: "swiper-slide"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "imgbox",
  id: "imgbox"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["id"];
const _hoisted_12 = ["id"];
const _hoisted_13 = {
  key: 2,
  class: "btns"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.detail.name), 1), $data.detail.type == '3D' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "containRelics",
    style: _normalizeStyle(`${$data.showModels[1] || $data.showModels[0] ? `${$options.isMobile ? 'right: 100vw' : 'right: -22vw'}` : ''}`)
  }, null, 4)) : _createCommentVNode("", true), $data.detail.type == '图片' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_8)]);
  }), 256))])], 512)]), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "prev btn fc_l"
  }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "next btn fc_r"
  }, null, -1))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: "containRelics360",
    style: _normalizeStyle(`${$data.showModels[1] || $data.showModels[0] ? `${$options.isMobile ? 'right: 100vw' : 'right: -22vw'}` : ''}`)
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images360, item => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_10)]);
  }), 256))])]), _cache[5] || (_cache[5] = _createElementVNode("div", {
    id: "threesixty"
  }, [_createElementVNode("div", {
    id: "spinner"
  }, [_createElementVNode("span", null, "0%")]), _createElementVNode("ol", {
    id: "threesixty_images"
  })], -1))], 4), [[_vShow, $data.detail.type == '360']]), _createElementVNode("div", {
    id: `loadbar_${$data.detail.code}`,
    class: "loadbar"
  }, [_createElementVNode("span", {
    id: `bar_${$data.detail.code}`,
    style: {
      "width": "0%"
    },
    class: "bar"
  }, null, 8, _hoisted_12)], 8, _hoisted_11), $data.showDebug ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", {
    class: "debugButton",
    onClick: _cache[0] || (_cache[0] = $event => $options.test())
  }, "预览"), _createElementVNode("div", {
    class: "debugButton",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.reset && $options.reset(...args))
  }, "重置"), _createElementVNode("div", {
    class: "debugButton",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.saveParams())
  }, "保存")])) : _createCommentVNode("", true)]);
}